import type { NavigationTabs } from '@flowx/designer/modules/projects/utils/navigation-tabs.util'
import type { EntryPointLaunchResult } from '@flowx/designer/shared/services/start-process.service'

export enum SolutionAction {
  RUN = 'run',
  SHARED = 'shared',
  INVITED = 'invited',
  ACCESS_CHANGED = 'access_changed',
  ROLE_CHANGED = 'role_changed',
}

/** Run in the project header. The org Solutions list sends `solution_run` without properties. */
export type SolutionRunAnalyticsObject = {
  event: { object: 'solution'; action: SolutionAction.RUN }
  properties: { source: 'header'; result: EntryPointLaunchResult; tab: NavigationTabs }
}
